import { FuelTypography } from '@frete.com/fuel-react';
import mobile from 'is-mobile';

import { Grid } from '~components';
import { ReactComponent as CreditAnalysis } from '~assets/credit-analysis-mobile.svg';

import CheckListItem from '../CheckList';
import * as Styled from '../Credit.styled';

function Analysis() {
  const isMobile = mobile();

  return (
    <Styled.Container>
      <Grid container spacing={10} direction="column">
        <Grid className="img-credit-analysis">
          <CreditAnalysis />
        </Grid>
        <Grid>
          <FuelTypography
            size={isMobile ? 'heading-lg' : 'display-lg'}
            variant="bold"
          >
            Conclua a abertura da sua Conta PJ Fretebras
          </FuelTypography>
        </Grid>
        <Grid>
          <FuelTypography
            size={isMobile ? 'body-sm' : 'body-lg'}
            color="neutral-default"
          >
            Uma análise de crédito para sua empresa está em andamento, conclua a
            abertura da sua{' '}
            <Styled.Highlight>Conta PJ Fretebras</Styled.Highlight> para
            usufruir dos demais benefícios:
          </FuelTypography>
        </Grid>
        <CheckListItem />
        <Grid>
          <FuelTypography
            size="caption"
            weight="medium"
            color="neutral-default"
          >
            A análise de crédito pode levar até 2 dias e iremos lhe comunicar
            por e-mail.
          </FuelTypography>
        </Grid>
      </Grid>
    </Styled.Container>
  );
}

export default Analysis;
